export const SUPPORTED_CURRENCIES = {
  GBP: 'GBP',
  USD: 'USD',
};

const CURRENCY_CONFIG = {
  [SUPPORTED_CURRENCIES.GBP]: {
    locale: 'en-GB',
    currency: 'GBP',
  },
  [SUPPORTED_CURRENCIES.USD]: {
    locale: 'en-US',
    currency: 'USD',
  },
};

export const formatCurrency = (value, currency = SUPPORTED_CURRENCIES.GBP) => {
  // Default to GBP if currency is not supported
  const config = CURRENCY_CONFIG[currency] || CURRENCY_CONFIG[SUPPORTED_CURRENCIES.GBP];
  
  return new Intl.NumberFormat(config.locale, {
    style: 'currency',
    currency: config.currency,
    maximumFractionDigits: 0,
  }).format(value);
};